module.exports = __webpack_public_path__ + "static/feature-board-bb93897a41b42b559b675e7dcd7cee70.png";